/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import React, { Component } from 'react';
// material
import Button from 'material/ctas/button/button_container';
// styles
import injectSheet from 'react-jss';
import styles from 'material/embeds/embed/edit/addanswer/addanswer_styles';



/* ========== ~~~~~~~~~~ EMBED : ADD ANSWER : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class AddAnswer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }
	handleClick() {
		this.props.addOption(this.props.contentId)
	}
    render() {
        if (this.props.numberOfOptions === 4) { return null; }
        return(
            <Button type={`custom`} handleClick={this.handleClick} variant={`system`} name={`addanswer`} text={`+ Add Answer`} klass={`${this.props.classes.addanswer} editorelement`} />
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
// will be utilized in parent component after being infused with app state & actions
export default injectSheet(styles)(AddAnswer);
